// ==============================================
// ==================Import======================
// ==============================================

// ==================Dependancies=================

import {
  Accordion, AccordionDetails, AccordionSummary,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';

// =================Actions======================

import {
  saveAntennaTypeSelected,
  saveRadomeTypeSelected,
  saveReceiverTypeSelected,
  saveSatelliteSystemSelected,
  setAccordionExpanded,
  setAttributeChannel,
  setClockQc,
  setCycleQc,
  setDailyObservation,
  setDataAvailability,
  setDatePickerAdvancedSearchDateFrom,
  setDatePickerAdvancedSearchDateTo,
  setElevationQc,
  setEpochQc,
  setFileStatusSelected,
  setFileTypeSelected,
  setFrequenciesBand,
  setMultipathQc,
  setObservationsTypes,
  setSatelliteSystemQc,
  setSinglePointQc,
} from '../../../actions/site';

// ==================Style&IMG===================
import './style.scss';

function AdvancedSearch() {
  // ==================HOOKS=======================
  const dispatch = useDispatch();
  const expanded = useSelector((state) => state.site.advancedSearch.expanded);
  const receiverList = useSelector((state) => state.site.advancedSearch.receiverList);
  const antennaList = useSelector((state) => state.site.advancedSearch.antennaList);
  const radomeList = useSelector((state) => state.site.advancedSearch.radomeList);
  const satelliteSystem = useSelector((state) => state.site.advancedSearch.satelliteSystem);
  const fileTypeList = useSelector((state) => state.site.advancedSearch.fileTypeList);
  const statusFile = useSelector((state) => state.site.advancedSearch.statusFile);
  const statusNodeFile = useSelector((state) => state.site.advancedSearch.statusNodeFile);
  const typeOfSignal = useSelector((state) => state.site.advancedSearch.typeOfSignal);
  const frequencies = useSelector((state) => state.site.advancedSearch.frequencies);
  const chanel = useSelector((state) => state.site.advancedSearch.chanel);
  const satelliteSystemT3 = useSelector((state) => state.site.advancedSearch.satelliteSystemT3);
  const dateFromAdvancedSearch = useSelector(
    (state) => state.site.advancedSearch.fileInfo.dateFrom,
  );
  const dateToAdvancedSearch = useSelector(
    (state) => state.site.advancedSearch.fileInfo.dateTo,
  );
  const dataAvailability = useSelector(
    (state) => state.site.advancedSearch.fileInfo.dataAvailability,
  );
  const dailyObservation = useSelector(
    (state) => state.site.advancedSearch.fileInfo.dailyObservation,
  );
  const epoch = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.epoch,
  );
  const elevation = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.elevation,
  );
  const multipath = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.multipath,
  );
  const cycle = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.cycle,
  );
  const singlePoint = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.singlePoint,
  );
  const clock = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.clock,
  );
  const receiverTypeState = useSelector(
    (state) => state.site.advancedSearch.equipement.receiverType,
  );
  const antennaTypeState = useSelector((state) => state.site.advancedSearch.equipement.antennaType);
  const radomeTypeState = useSelector((state) => state.site.advancedSearch.equipement.radomeType);
  const satelliteSystemState = useSelector(
    (state) => state.site.advancedSearch.equipement.satelliteSystem,
  );
  const fileTypeState = useSelector((state) => state.site.advancedSearch.fileInfo.fileType);
  const fileStatusState = useSelector((state) => state.site.advancedSearch.fileInfo.fileStatus);
  const observationsTypesState = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.observationsTypes,
  );
  const frequenciesBandState = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.frequenciesBand,
  );
  const attributeChannelState = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.attributeChannel,
  );
  const satelliteSystemQcState = useSelector(
    (state) => state.site.advancedSearch.QCFileInfo.satelliteSystem,
  );
  // ==================Handler=====================
  // handler to display accrdion of advanced search
  const handleAccordionExpanded = (panel) => {
    if (!expanded) {
      dispatch(setAccordionExpanded(panel));
    }
    else {
      dispatch(setAccordionExpanded(false));
      dispatch(setAccordionExpanded(panel));
    }
  };

  // function to change date format and save date picker value selected by user in state
  function handleChangeDateFromAdvancedSearch(value) {
    const valuetransform = `${value.$d.toString().substring(0, 15)} 00:00:00 GMT+0000`;
    dispatch(
      setDatePickerAdvancedSearchDateFrom(new Date(valuetransform).toISOString().substring(0, 10)),
    );
  }

  function handleChangeDateToAdvancedSearch(value) {
    const valuetransform = `${value.$d.toString().substring(0, 15)} 00:00:00 GMT+0000`;
    dispatch(
      setDatePickerAdvancedSearchDateTo(new Date(valuetransform).toISOString().substring(0, 10)),
    );
  }

  // function to save in state the data availabilty
  const handleDataAvailability = (evt) => {
    if (evt.target.value > 100) {
      dispatch(setDataAvailability('100'));
    }
    else if (evt.target.value < 0) {
      dispatch(setDataAvailability('0'));
    }
    else {
      dispatch(setDataAvailability(evt.target.value));
    }
  };

  // save in state number of daily observtion
  const handleDailyObservation = (evt) => {
    dispatch(setDailyObservation(evt.target.value));
  };

  // save value of file onfo input QC
  const handleQCFileInfoInput = (evt) => {
    if (evt.target.className === 'epoch--qc') {
      dispatch(setEpochQc(evt.target.value));
    }
    else if (evt.target.className === 'elevation--qc') {
      dispatch(setElevationQc(evt.target.value));
    }
    else if (evt.target.className === 'multipath--qc') {
      dispatch(setMultipathQc(evt.target.value));
    }
    else if (evt.target.className === 'cycle--qc') {
      dispatch(setCycleQc(evt.target.value));
    }
    else if (evt.target.className === 'single--point--qc') {
      dispatch(setSinglePointQc(evt.target.value));
    }
    else if (evt.target.className === 'clock--qc') {
      dispatch(setClockQc(evt.target.value));
    }
  };

  // Generic click handler for panel1 selects
  const handleOptionClick = (className, value, ctrlKey, shiftKey) => {
    let current = [];
    let saveAction;
    switch (className) {
      case 'receiver--type':
        current = receiverTypeState;
        saveAction = saveReceiverTypeSelected;
        break;
      case 'antenna--type':
        current = antennaTypeState;
        saveAction = saveAntennaTypeSelected;
        break;
      case 'radome--type':
        current = radomeTypeState;
        saveAction = saveRadomeTypeSelected;
        break;
      case 'satellite--system':
        current = satelliteSystemState;
        saveAction = saveSatelliteSystemSelected;
        break;
      case 'file--type':
        current = fileTypeState;
        saveAction = setFileTypeSelected;
        break;
      case 'file--status':
        current = fileStatusState;
        saveAction = setFileStatusSelected;
        break;
      case 'observations--types':
        current = observationsTypesState;
        saveAction = setObservationsTypes;
        break;
      case 'frequencies--band':
        current = frequenciesBandState;
        saveAction = setFrequenciesBand;
        break;
      case 'attribute--channel':
        current = attributeChannelState;
        saveAction = setAttributeChannel;
        break;
      case 'satellite--system--qc':
        current = satelliteSystemQcState;
        saveAction = setSatelliteSystemQc;
        break;
      default:
        return;
    }
    let nextSelected;
    if (ctrlKey || shiftKey) {
      if (current.includes(value)) {
        nextSelected = current.filter((v) => v !== value);
      }
      else {
        nextSelected = [...current, value];
      }
    }
    else if (current.length === 1 && current[0] === value) {
      nextSelected = [];
    }
    else {
      nextSelected = [value];
    }
    dispatch(saveAction(nextSelected));
  };

  return (
    <div className="panel-group" role="tablist" aria-multiselectable="true">
      <div className="panel panel-default">
        <Accordion className="accordion" expanded={expanded === 'panel1'} onChange={() => handleAccordionExpanded('panel1')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <div className="panel-heading" role="tab">
              Monumentation / Equipment
            </div>
          </AccordionSummary>
          <AccordionDetails className="panelAccordionDetails" style={{ height: '100%' }}>
            <div className="panel-collapse" role="tabpanel">
              <div className="panel-body">
                <div id="fieldconteneur">
                  <div>
                    <p className="para">Receiver Type</p>
                    <select multiple className="receiver--type" value={receiverTypeState} onChange={() => { /* no-op, just to satisfy React */ }} onMouseDown={(e) => e.preventDefault()}>
                      {receiverList.map(
                        (el) => (
                          <option
                            value={el}
                            key={el}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              handleOptionClick('receiver--type', el, e.ctrlKey || e.metaKey, e.shiftKey);
                            }}
                          >
                            {el}
                          </option>
                        ),
                      )}
                    </select>
                  </div>
                  <div>
                    <p className="para">Antenna Type</p>
                    <select
                      multiple
                      className="antenna--type"
                      value={antennaTypeState}
                      onChange={() => { /* no-op */ }}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {antennaList.map((el) => (
                        <option
                          key={el}
                          value={el}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            handleOptionClick('antenna--type', el, e.ctrlKey || e.metaKey, e.shiftKey);
                          }}
                        >
                          {el}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <br />
                <div id="fieldconteneur">
                  <div>
                    <p className="para">Radome Type</p>
                    <select
                      multiple
                      className="radome--type"
                      value={radomeTypeState}
                      onChange={() => { /* no-op */ }}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {radomeList.map((el) => (
                        <option
                          key={el}
                          value={el}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            handleOptionClick('radome--type', el, e.ctrlKey || e.metaKey, e.shiftKey);
                          }}
                        >
                          {el}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <p className="para">Satellite System</p>
                    <select
                      multiple
                      className="satellite--system"
                      value={satelliteSystemState}
                      onChange={() => { /* no-op */ }}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {satelliteSystem.map((el) => (
                        <option
                          key={el.name}
                          value={el.name}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            handleOptionClick('satellite--system', el.name, e.ctrlKey || e.metaKey, e.shiftKey);
                          }}
                        >
                          {el.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>

        <Accordion className="accordion" expanded={expanded === 'panel2'} onChange={() => handleAccordionExpanded('panel2')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
          >
            <div className="panel-heading" role="tab">
              File Info
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className="panel-collapse" role="tabpanel">
              <div className="panel-body">
                <div id="fieldconteneur">
                  <div id="fieldconteneur--datePicker">
                    <p className="para">Date Range</p>
                    <div id="datepickerrange">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker
                            label="Date from :"
                            format="YYYY-MM-DD"
                            slotProps={{
                              textField: {
                                helperText: 'YYYY-MM-DD',
                                error: false,
                              },
                            }}
                            value={dateFromAdvancedSearch}
                            maxDate={dayjs(dateToAdvancedSearch)}
                            onChange={(value) => handleChangeDateFromAdvancedSearch(value)}
                          />
                          <DatePicker
                            label="Date to :"
                            format="YYYY-MM-DD"
                            slotProps={{
                              textField: {
                                helperText: 'YYYY-MM-DD',
                                error: false,
                              },
                            }}
                            value={dateToAdvancedSearch}
                            minDate={dayjs(dateFromAdvancedSearch)}
                            onChange={(value) => handleChangeDateToAdvancedSearch(value)}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
                <br />
                <div id="fieldconteneur">
                  <div>
                    <p className="para">Data Availability</p>
                    <input type="number" size="3" title="percent" max={100} min={0} value={dataAvailability} onChange={handleDataAvailability} /> %
                  </div>
                  <div>
                    <p className="para">Daily observation '{'>'}' than</p>
                    <input type="number" size="3" title="Daily observation superior than" value={dailyObservation} onChange={handleDailyObservation} /> years
                  </div>
                </div>
                <br />
                <div id="fieldconteneur">
                  <div>
                    <p className="para">File Type</p>
                    <select
                      multiple
                      className="file--type"
                      value={fileTypeState}
                      onChange={() => { /* no-op */ }}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {fileTypeList.map((el) => (
                        <option
                          key={el.name}
                          value={el.name}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            handleOptionClick('file--type', el.name, e.ctrlKey || e.metaKey, e.shiftKey);
                          }}
                        >
                          {el.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <p className="para">File Status</p>
                    <select
                      multiple
                      className="file--status"
                      value={fileStatusState}
                      onChange={() => { /* no-op */ }}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {(process.env.REACT_APP_TYPE_CLIENT === 'dgw' ? statusFile : statusNodeFile).map((el) => (
                        <option
                          key={el.name}
                          value={el.name}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            handleOptionClick('file--status', el.name, e.ctrlKey || e.metaKey, e.shiftKey);
                          }}
                        >
                          {el.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>

        <Accordion className="accordion" expanded={expanded === 'panel3'} onChange={() => handleAccordionExpanded('panel3')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
          >
            <div className="panel-heading" role="tab">
              QC File Info
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className="panel-collapse" role="tabpanel">
              <div className="panel-body">
                <div id="fieldconteneur">
                  <div>
                    <p className="para">Observations Types</p>
                    <select multiple className="observations--types" value={observationsTypesState} onChange={() => { /* no-op, just to satisfy React */ }} onMouseDown={(e) => e.preventDefault()}>
                      {typeOfSignal.map(
                        (el) => (
                          <option
                            value={el.name}
                            key={el.name}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              handleOptionClick('observations--types', el.name, e.ctrlKey || e.metaKey, e.shiftKey);
                            }}
                          >
                            {el.name}
                          </option>
                        ),
                      )}
                    </select>
                  </div>
                  <div>
                    <p className="para">Frequencies Band</p>
                    <select multiple className="frequencies--band" value={frequenciesBandState} onChange={() => { /* no-op, just to satisfy React */ }} onMouseDown={(e) => e.preventDefault()}>
                      {frequencies.map(
                        (el) => (
                          <option
                            value={el.name}
                            key={el.name}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              handleOptionClick('frequencies--band', el.name, e.ctrlKey || e.metaKey, e.shiftKey);
                            }}
                          >
                            {el.name}
                          </option>
                        ),
                      )}
                    </select>
                  </div>
                </div>
                <br />
                <div id="fieldconteneur">
                  <div>
                    <p className="para">Attribute Channel</p>
                    <select multiple className="attribute--channel" value={attributeChannelState} onChange={() => { /* no-op, just to satisfy React */ }} onMouseDown={(e) => e.preventDefault()}>
                      {chanel.map(
                        (el) => (
                          <option
                            value={el.name}
                            key={el.name}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              handleOptionClick('attribute--channel', el.name, e.ctrlKey || e.metaKey, e.shiftKey);
                            }}
                          >
                            {el.name}
                          </option>
                        ),
                      )}
                    </select>
                  </div>
                  <div>
                    <p className="para">Satellite System</p>
                    <select multiple className="satellite--system--qc" value={satelliteSystemQcState} onChange={() => { /* no-op, just to satisfy React */ }} onMouseDown={(e) => e.preventDefault()}>
                      {satelliteSystemT3.map(
                        (el) => (
                          <option
                            value={el.name}
                            key={el.name}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              handleOptionClick('satellite--system--qc', el.name, e.ctrlKey || e.metaKey, e.shiftKey);
                            }}
                          >
                            {el.name}
                          </option>
                        ),
                      )}
                    </select>
                  </div>
                </div>
                <br />
                <div id="fieldconteneur">
                  <div>
                    <p className="para">Epoch Completeness '{'>'}' than</p>
                    <input type="text" size="3" title="length of data window, # of data epochs,# of data gaps/small data pieces" className="epoch--qc" value={epoch} onChange={handleQCFileInfoInput} />
                    <br />
                  </div>
                  <div>
                    <p className="para">Elevation Angle inferior than</p>
                    <input type="text" size="3" title="min/max elevation mask" className="elevation--qc" value={elevation} onChange={handleQCFileInfoInput} />
                    deg
                    <br />
                  </div>
                </div>
                <br />
                <div id="fieldconteneur">
                  <div>
                    <p className="para">
                      Mean Multipath C1/P2(GPS)
                      <br />
                      inferior than
                    </p>
                    <input type="text" size="3" title="e.g. min/max mean code multipath" className="multipath--qc" value={multipath} onChange={handleQCFileInfoInput} />
                    cm
                    <br />
                  </div>
                  <div>
                    <p className="para">#Cycle Slips</p>
                    <br />
                    <input type="text" size="3" title="e.g. min/max number of cycle slips / interruptions" className="cycle--qc" value={cycle} onChange={handleQCFileInfoInput} />
                  </div>
                </div>
                <br />
                <div id="fieldconteneur">
                  <div>
                    <p className="para">
                      Single Point Positioning
                      <br />
                      RMS(GPS) inferior than
                    </p>
                    <input type="text" size="3" title="e.g. min max standard point positioning RMS" className="single--point--qc" value={singlePoint} onChange={handleQCFileInfoInput} />
                    meter
                    <br />
                  </div>
                  <div>
                    <p className="para">#Clock Jump</p>
                    <br />
                    <input type="text" size="3" title="e.g. min/max number of clock jumps" className="clock--qc" value={clock} onChange={handleQCFileInfoInput} />
                  </div>
                </div>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}

export default AdvancedSearch;
